var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VAutocomplete',{attrs:{"items":_vm.displayAnalysis,"multiple":"","outlined":""},on:{"change":_vm.UpdateData},model:{value:(_vm.selectedAnalyses),callback:function ($$v) {_vm.selectedAnalyses=$$v},expression:"selectedAnalyses"}})}
var staticRenderFns = []

export { render, staticRenderFns }